// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"198":"board","443":"about"}[chunkId] + "." + {"198":"d14c3bdf","443":"ccc0c8d4"}[chunkId] + ".css";
};